import { STATE_CATEGORY } from '../types/stateCategory';
import { CategoryOption } from './modeCategoryOptions';

/** State Category dropdown options — pure catalog labels for `STATE_CATEGORY`'s values. Same set for the "basic" and "extended" (storm-mode) variants. */
export const STATE_CATEGORY_OPTIONS: CategoryOption[] = [
  { label: '', value: STATE_CATEGORY.NONE },
  { label: 'On', value: STATE_CATEGORY.ON },
  { label: 'Off', value: STATE_CATEGORY.OFF },
  { label: 'Filtration', value: STATE_CATEGORY.FILTRATION },
  { label: 'Backwash', value: STATE_CATEGORY.BACKWASH },
  { label: 'Relax', value: STATE_CATEGORY.RELAX },
  { label: 'CEB', value: STATE_CATEGORY.CEB },
  { label: 'CIP', value: STATE_CATEGORY.CIP },
  { label: 'Recirculation', value: STATE_CATEGORY.RECIRCULATION },
  { label: 'Forward Flush', value: STATE_CATEGORY.FORWARD_FLUSH },
  { label: 'Rinse', value: STATE_CATEGORY.RINSE },
  { label: 'Heating', value: STATE_CATEGORY.HEATING },
  { label: 'Filling', value: STATE_CATEGORY.FILLING },
];
